import { Box, DialogContent, DialogTitle } from "@mui/material";
import { profileBussiness } from "api/bussiness/auth/profile-bussiness";
import { ChangePasswordRequest } from "api/models/request/profile";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { string } from "yup";
export interface ChangePasswordFormModel extends ChangePasswordRequest {
  confirmNewPassword: string;
}
export const ChangePw = observer(() => {
  const {
    authentication: { openChangePw, setProp },
  } = useStores();
  const {
    submitHandler,
    form: { isValid, controls, reset },
    getControl,
  } = useForm<ChangePasswordFormModel>(
    {
      currentPassword: {
        type: InputType.password,
        label: "Mật khẩu hiện tại",
        gridSize: 12,
        validattionYupSchema: string().required(),
      },
      newPassword: {
        label: "Mật khẩu mới",
        type: InputType.password,
        gridSize: 12,
        validattionYupSchema: string().required(),
      },
      confirmNewPassword: {
        type: InputType.password,
        label: "Nhập lại mật khẩu mới",
        gridSize: 12,
        validattionYupSchema: string()
          .required()
          .test("pw-match", "Chưa trùng khớp !", (val: string): any => {
            return val === (getControl("newPassword").value as string);
          }),
      },
    },
    {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    }
  );

  useEffect(() => {
    if (openChangePw) {
      reset();
    }
  }, [openChangePw, reset]);

  const saveHandler = useCallback(
    async (data: ChangePasswordFormModel) => {
      await profileBussiness.changePassword({
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
      });
      setProp("openChangePw", false);
    },
    [setProp]
  );
  return (
    <DialogForm
      fullWidth
      maxWidth="xs"
      open={openChangePw}
      onClose={() => setProp("openChangePw", false)}
      onCancelBtnClicked={() => setProp("openChangePw", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Đổi mật khẩu</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
